module.exports = __webpack_public_path__ + "img/css.1a58b2d2.svg";